import { PropsWithChildren } from 'react';
import { Button, IconButton, IconName, Stack, Typography, useScrollable } from '@optimus-web/core';
import { FilterSidebarActions, FilterSidebarContent, FilterSidebarHeader, FilterSidebarWrapper } from './styles';
import { FilterSidebarProps } from './types';

export const FilterSidebar = ({
    title,
    actions,
    children,
    toggle,
    onClose,
    primaryButton,
    loading,
    ...other
}: PropsWithChildren<FilterSidebarProps>) => {
    const { hasScrollBar, contentRef } = useScrollable();
    const handleOnClick = primaryButton?.onClick;

    return (
        <FilterSidebarWrapper {...other} data-test-filter-sidebar>
            <Stack fill vertical>
                <FilterSidebarHeader spacing="200" itemAlignment="center" hasScrollBar={hasScrollBar}>
                    <IconButton
                        icon={IconName.CrossClose}
                        size="small"
                        onClick={() => {
                            if (onClose) {
                                onClose();
                            }
                            toggle(false);
                        }}
                        type="button"
                        data-test-close-filter-sidebar
                    />
                    <Typography textStyle="titleMediumStrong" as="div">
                        {title}
                    </Typography>
                </FilterSidebarHeader>
                <FilterSidebarContent grow ref={contentRef}>
                    {children}
                </FilterSidebarContent>
                <FilterSidebarActions spacing="150" alignment="end" itemAlignment="center" hasScrollBar={hasScrollBar}>
                    {actions}
                    {primaryButton ? (
                        <Button
                            size="medium"
                            variant="primary"
                            type={primaryButton.type || 'button'}
                            onClick={handleOnClick}
                            form={primaryButton.formId}
                            loading={loading}
                        >
                            {primaryButton.label}
                        </Button>
                    ) : null}
                </FilterSidebarActions>
            </Stack>
        </FilterSidebarWrapper>
    );
};
